<template>
  <div class="l-container">
      <div class="content">
        <slot />
      </div>
  </div>
</template>

<script>
export default {
    name: 'l-container',
    props:{
        bg:{
            default: ''
        },
        src:{
            default: ''
        }
    },
    computed: {

        _bg(){
            return {
                backgroundColor: this.bg,
            }
        },

    }
    
}
</script>
<style lang="scss" scoped>
.l-container{

    
    .content{
        margin: auto;
        width: 1200px;
        background: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1567657530834&di=e56ca945f99e13aca8c7c36e72558c02&imgtype=0&src=http%3A%2F%2Fphotocdn.sohu.com%2F20110722%2FImg314235964.jpg') no-repeat center ;
        background-size: 100% auto;
    }
    
}

</style>